import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import "../CaseDetails/CaseDetails.css";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
import TableComponent from "../../components/TableComponent";
import { Link, useNavigate, useParams } from "react-router-dom";
import Title from "../../components/title";

function ShowDependData(props) {

    const columns = [
        { name: "إسم التابع", key: "name" },
        { name: " تاريخ الميلاد", key: "dateofbirth" },
        { name: "رقم الهاتف", key: "phone" },
        { name: "صلة القرابة", key: "relation" },
        { name: "النوع", key: "gender" },
        { name: "ملاحظات", key: "note" },
        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState([]);
    const navigate = useNavigate();
    const { id } = useParams();


    const dropdownOptions = [
        { label: "تعديل", route: `/editDependentsData/:id` },

    ];


    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const modifyRow = (row) => {
        let newRow = { ...row };
        newRow.gender = row.gender === 0 ? "ذكر" : "أنثى";
        return newRow;
    };

    return (

        <>
            <div className="printcasedata-container employpaper ">
                <Title title="بيانات التابعين" style={{ width: "unset" }} classname='rmtit' icon={<FontAwesomeIcon icon={faReceipt} />} />


                <Link to={`/DependentsData/${id}`} className="archive-report archive-report2">
                    <span  className="add-row-ta archiveAdd "   >اضافة تابع جديد</span>
                </Link>
                <TableComponent
                    apiUrl={`/humancasedetails/showdependantsdata/${id}`}
                    columns={columns}
                    // title=" بيانات التابعين"
                    // titleIcon={<FontAwesomeIcon icon={faReceipt} />}
                    dropdownOptions={dropdownOptions}
                    searchDate={false}
                    transformRowFn={modifyRow}
                />
            </div>
        </>
    );
}

export default ShowDependData;
